import './QuizList.scss'

import { useHistory } from 'react-router-dom'
import parse from 'html-react-parser'

import { getQuizPath } from 'components/common/helpers/Paths'
import { navigateTo } from 'components/common/navigation'
import { Button, Col, Row } from 'react-bootstrap'

/**
 * Quiz List component. Used for displaying a list of quizzes.
 */
export default function QuizList({ quizzes, courseId, topic, lesson }) {
  const history = useHistory()

  /**
   * Navigation helper to load the quiz
   * @param {Number} quizId The quiz id to load
   * @returns History object
   */
  const loadQuiz = quizId =>
    navigateTo(getQuizPath(courseId, lesson.id, topic.id, quizId), history)

  // No need to proceed with render if we don't have any quizzes
  if (!quizzes || !quizzes.length) return null

  return (
    <Row className='quiz-wrapper' xs={1} md={2} lg={4}>
      {quizzes.map(quiz => (
        <Col
          className={`quiz ${quiz?.content?.rendered ? 'has-intro' : ''}`}
          key={quiz.id}
        >
          {/* TODO: Add flag in LearnDash to check for optionality
          <span className='optional'>Optional</span> */}
          {quiz?.content?.rendered ? (
            <>
              <h3 className='quiz-title'>{quiz.clean_title}</h3>
              <div>{parse(quiz.content.rendered)}</div>

              <Button variant='primary' onClick={_ => loadQuiz(quiz.id)}>
                <span>
                  Start <i className='icon bi-arrow-right'></i>
                </span>
              </Button>
            </>
          ) : (
            <>
              <Button
                variant='outline-primary'
                onClick={_ => loadQuiz(quiz.id)}
              >
                <span>
                  Start {quiz.clean_title}{' '}
                  <i className='icon bi-arrow-right'></i>
                </span>
              </Button>
            </>
          )}
        </Col>
      ))}
    </Row>
  )
}
